export default __webpack_public_path__ + "static/media/phone.ef06aca9.svg";